import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

export const INITIAL_BASIC_LIST = {
  type: '',
  usedType: '',
  filterList1: [],
  usedFilter1: [],
}

export const INITIAL_FILTER_LIST = {
  ...INITIAL_BASIC_LIST,
  filterList2: [],
  usedFilter2: [],
  boxHeight: 40,
}

export const modalAddRegister = createSlice({
  name: 'filterSearch',
  initialState: {
    basicList: INITIAL_BASIC_LIST,
    filtersList: [INITIAL_FILTER_LIST],
    itemsAvailable: [],
    advancedSearch: false,
    advancedSearchUsed: false,
    filter: false,
    enable: false,
  },
  reducers: {
    setSearchByType: (state, action) => {
      state.basicList.type = action.payload
    },
    setTypeSearchUsed: (state, action) => {
      state.basicList.usedType = action.payload
    },
    basicListInitial: state => {
      state.basicList = INITIAL_BASIC_LIST
    },
    setSelectedList: (state, action) => {
      state.basicList.filterList1 = action.payload
    },
    setFiltersUsed: (state, action) => {
      state.basicList.usedFilter1 = action.payload
    },
    setFiltersList: (state, action) => {
      state.filtersList = action.payload
    },
    filterListInitial: state => {
      state.filtersList = [INITIAL_FILTER_LIST]
    },
    updateFilterListByID: (state, action) => {
      const { someId, someValue } = action.payload
      state.filtersList[someId] = someValue
    },
    setAdvancedSearch: (state, action) => {
      state.advancedSearch = action.payload
    },
    setAdvancedSearchUsed: (state, action) => {
      state.advancedSearchUsed = action.payload
    },
    setFilterState: (state, action) => {
      state.filter = action.payload
    },
    setANewFilterInList: (state, action) => {
      state.filtersList[action.payload + 1] = INITIAL_FILTER_LIST
    },
    removeFilterInList: (state, action) => {
      _.remove(state.filtersList, (n, i) => i === action.payload)
    },
    removeItemsAvailable: (state, action) => {
      _.remove(state.itemsAvailable, (n, i) => i === action.payload)
    },
    setBoxHeight: (state, action) => {
      const { someId, someValue } = action.payload
      state.filtersList[someId].boxHeight = someValue
    },
    setEnabledFilter: (state, action) => {
      state.enable = action.payload
    },
  },
})

export const {
  basicListInitial,
  setSearchByType,
  setTypeSearchUsed,
  setSelectedList,
  setFilterState,
  setFiltersUsed,
  setFiltersList,
  filterListInitial,
  updateFilterListByID,
  setAdvancedSearch,
  setAdvancedSearchUsed,
  setANewFilterInList,
  removeFilterInList,
  setBoxHeight,
  setEnabledFilter,
} = modalAddRegister.actions
export default modalAddRegister.reducer
